export default __webpack_public_path__ + "static/media/matheus.453aaa16.jpg";